import { buildPath, CollectionType, pathFromType } from '../firestore';

export function buildUserDataCollectionPath({ userId }: { userId: string | null }): string {
    return buildPath(pathFromType(CollectionType.userData), userId);
}
